
import CloseIcon from '@mui/icons-material/Close';
import {AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import usePostRequest from '../../hooks/usePostRequest';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';

function DialogRejetCraAndCraX({ idCra, idCraX, updateCraX,refreshCra, openDialogRejetCras, setOpenDialogRejetCras}) {
    DialogRejetCraAndCraX.propTypes = {
        idCra: PropTypes.any,
        idCraX: PropTypes.any,
        openDialogRejetCras: PropTypes.any,
        setOpenDialogRejetCras: PropTypes.func,
        refreshCra: PropTypes.func,
        updateCraX: PropTypes.func,
    };
    const handleCloseDialogRejetCraAndCraX = () => {
        setOpenDialogRejetCras(false);
    };
    //======================= var ==================================================
    let navigate = useNavigate();
    const { postData } = usePostRequest();
    const [description, setDescription] = useState('');
    const { i18n } = useTranslation();
    const {device}=useWindowSize();
    //============================update le motif de Rejet du cra ===================
    // function postCM() {
    //     axios.post('Cra/updateCraMR/' + idCra, { motifR: description })
    //         .then(() => { console.log('updated'); })
    //         .catch(error => console.log(error));
    // }
    //============================update le statut vers non validé =================================
    const rejectCraCraX = async () => {
        if(idCraX){
            try {
                const response = await postData({
                    url: '/cra/updateStatutCraXByClient',
                    payload: {
                        craXId: idCraX,
                        statutCraX: 'NV',
                        motifR: description
                    }
                });
                // meme on reste plus dans la page :)
                updateCraX(response.data?.updatedCraX);
            } catch (error) {
                console.log(error);
            }
        }
        else if(idCra){
            try {
                await postData({ url: `/cra/rejectCra/${idCra}`,payload: { motifR: description } });
                handleCloseDialogRejetCraAndCraX();
                refreshCra();
            } catch (error) {
                console.log(error);
            }
        }
    };
    //=================================================================================
    if (!open) return null;

    return(
        <Dialog
            open={openDialogRejetCras}
            onClose={handleCloseDialogRejetCraAndCraX}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseDialogRejetCraAndCraX}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <form style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px' }}>
                <div className='OrdreMissionFileFrame18'>
                    {/*<h5 className='OrdreMissionFileFrame19'>
                    Demande d&apos;interruption de idDoc
                    </h5>*/}
                    <div className='OrdreMissionFileFrame20'>
                        <div className='OrdreMissionFileFrame26'>
                            <div className='OrdreMissionFileFrame23'>
                                <p className='OrdreMissionFileFrame24'>{i18n.t('Motif de rejet')} </p>
                            </div>
                            <div className='OrdreMissionFileFrame27'>
                                <TextFieldComponent
                                    name="description"
                                    placeholder={i18n.t('motif du rejet')}
                                    multiline
                                    minRows={4}
                                    value={description}
                                    style={{width:'100%'}}
                                    onChange={(e) => setDescription(e.target.value)}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px'},
                                    }}
                                    autoFocus={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='OrdreMissionFileFrame28'>
                        <Button
                            onClick={handleCloseDialogRejetCraAndCraX}
                            variant="text"
                            style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}
                            }}
                        >{i18n.t('Annuler')}</Button>

                        <Button
                            variant="contained"
                            type='submit'
                            style={{
                                ...buttonStyles(),...{background:'#EC5B56',width:device=='desktop'?'auto':'100%',
                                    color:'#FFFFFF',}
                            }}
                            onClick={(e)=>{
                                e.preventDefault();
                                rejectCraCraX();
                                // postCM();
                                navigate(-1);
                                handleCloseDialogRejetCraAndCraX();
                            }}
                        //</div>onClick={()=> switchPropositionCommerciale('reject')}
                        >{i18n.t('Envoyer')}</Button>

                    </div>
                </div>
            </form>
        </Dialog>
    );
}

export default DialogRejetCraAndCraX;
